function checkBrowser () {
  var userAgent = navigator.userAgent;
  var isIE = userAgent.indexOf('Trident') > -1;
  var isOpera = userAgent.indexOf('OPR') > -1 || userAgent.indexOf('Opera') > -1; // 也有 Chrome/78.0.3904.108 Safari/537.36
  var isEdge = userAgent.indexOf('Edge') > -1; // 也有 Chrome/78.0.3904.108 Safari/537.36
  var isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Chromium') < 0 &&
    userAgent.indexOf('OPR') < 0 && userAgent.indexOf('Opera') < 0 && userAgent.indexOf('Edge') < 0;
  var isFF = userAgent.indexOf('Firefox') > -1 && userAgent.indexOf('Seamonkey') < 0;
  var isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') < 0 && userAgent.indexOf('Chromium') < 0;

  if (isIE) {
    return 'IE';
  }
  if (isOpera) {
    return 'Opera';
  }
  if (isEdge) {
    return 'Edge';
  }
  if (isChrome) {
    return 'Chrome';
  }
  if (isFF) {
    return 'FF';
  }
  if (isSafari) {
    return 'Safari';
  }
}
var name = checkBrowser();
if (name === 'IE') {
  console.log('IE: ', name);
  alert('您的浏览器不支持！请下载谷歌、火狐、UC、搜狗、360、edge、QQ、2345浏览器');
} else {
  console.log('其他: ', name);
}



// WEBPACK FOOTER //
// ./src/js/check.js